import React from "react";

const LoadingSpinner = ({
  size = "medium",
  color = "blue",
  className = "",
}) => {
  const sizeClasses = {
    small: "w-4 h-4 border-2",
    medium: "w-6 h-6 border-2",
    large: "w-8 h-8 border-2",
    xl: "w-12 h-12 border-4",
  };

  const colorClasses = {
    blue: "border-blue-500 border-t-transparent",
    green: "border-green-500 border-t-transparent",
    red: "border-red-500 border-t-transparent",
    purple: "border-purple-500 border-t-transparent",
    orange: "border-orange-500 border-t-transparent",
    gray: "border-gray-500 border-t-transparent",
    white: "border-white border-t-transparent",
  };

  return (
    <div
      className={`spinner ${sizeClasses[size]} ${colorClasses[color]} ${className}`}
    >
      <style jsx>{`
        .spinner {
          border-radius: 50%;
          animation: spin 1s linear infinite;
          display: inline-block;
        }

        @keyframes spin {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }
      `}</style>
    </div>
  );
};

export default LoadingSpinner;